@import "../../elevation.less";

.slobCard {
  .elevation-1();

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  position: relative;
  font-size: 1rem;
  background: white;
  border: 0;
  border-radius: 6px;
  overflow: hidden;
}

// Modes and toggles

.disabled {
  pointer-events: none;
}

@media print {
  &.printMode {
    box-shadow: none;
  }
}

.grow {
  height: 100%;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.1);

  &:hover {
    box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.15);
  }
}

// Variants

.activation {
  width: 555px;
  margin: 0 auto;
}

.task.slobCard {
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  transition: box-shadow 150ms linear;
  gap: 24px;
  cursor: pointer;

  p:last-of-type {
    margin-bottom: 0;
  }

  &:hover {
    .elevation-2();
  }

  &:active {
    .elevation-3();
  }

  svg {
    color: var(--color-tertiary-900);
  }

  &:hover svg {
    color: var(--color-secondary-900);
  }
}
